import React, { useMemo } from "react";
import {
  convertDateFormat,
  convertStringToArray,
  extractDate,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../../Utils/utils";
import Loader from "../../../components/Loader";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { imageUrl } from "../../../constants/constants";

const OtherCelebrations = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const navigate = useNavigate();
  const { data: otherEventsData, isLoading: otherEventsIsLoading } =
    useGetProtectedApiDataQuery({
      url: "other_celebration",
      lang: languageType,
    });

  // const lastUpdatedOn = useMemo(() => {
  //   return extractDateFromStr(getLatestUpdatedObject(otherEventsData)?.changed);
  // }, [otherEventsData]);

  const lastUpdatedOn = useMemo(() => {
    return extractDate(otherEventsData?.[0]);
  }, [otherEventsData]);

  const transformedData = otherEventsData?.map((item) => ({
    ...item,
    field_events_image: convertStringToArray(item.field_events_image),
  }));

  const handlePhotoClick = (nid) => {
    navigate(`/other-celebrations/${nid}`);
  };

  return (
    <div className="inner-container">
      <div className="container">
        <section className="ourCompany">
          <div className="container">
            <div className="row mb-2">
              <div className="title-sec">
                <h2>{getText("Photo Gallery", "फ़ोटो गैलरी")}</h2>
              </div>
              {transformedData?.map((item) => (
                <div
                  className="col-12 col-sm-12 col-md-3 col-lg-3 mvDescWrap print-gallery3"
                  key={item.nid}
                >
                  <div className="photo-gallery-area desc-sec photo-gallery-detail-page">
                    <div className="card-sec">
                      <div
                        className="img-sec"
                        onClick={() => handlePhotoClick(item.nid)}
                      >
                        <img
                          src={
                            imageUrl + item?.field_events_image?.[0]?.file_path
                          }
                          alt={item.title}
                        />
                      </div>
                      <div className="desc-sec">
                        {item?.field_date_media && (
                          <span className="date">
                            {convertDateFormat(item?.field_date_media)}
                          </span>
                        )}
                        <p>{item.title.slice(0, 70)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </div>
        </section>
      </div>
    </div>
  );
};

export default OtherCelebrations;
